<div class="rounded-xl p-2 sm:p-6">
    <div class="flex items-center justify-between mb-4">

        <h2 class="text-lg font-semibold text-indigo-900">{{ 'ONB_COMMITTEE.COMMITTEE_MEMBERS_LIST' | translate }}</h2>
        <div class="flex justify-between gap-6">
            @if (isRelationshipOfficer) {
            <button class="flex  gap-2 bg-indigo-600 text-white px-6 py-2 rounded-lg text-sm font-semibold"
                (click)="openPopup()">
                + {{ 'ONB_COMMITTEE.ADD_COMMITTEE' | translate }}
            </button>
            <button class="flex  gap-2 bg-indigo-600 text-white px-6 py-2 rounded-lg text-sm font-semibold"
                (click)="openMemberOnlyPopup()">
                + {{ 'ONB_COMMITTEE.COMMITTEE_MEMBER_ONLY' | translate }}
            </button>
            }
            <app-back-button></app-back-button>
        </div>

    </div>

    <div class="table-wrapper">
        <table class="table">
            <thead class="table-head">
                <tr>
                    <th>{{ 'ONB_COMMITTEE.COMMITTEE_NAME' | translate }}</th>
                    <th>{{ 'COMMON.CREATED_DATE' | translate }}</th>
                    <th class="text-center table-action-head">{{ 'COMMON.ACTION' | translate }}</th>
                </tr>
            </thead>

            <tbody>
                @for (row of list; track row.cmtSeq) {
                    <tr class="table-row cursor-pointer" (click)="toggleCommitteeRow(row)">
                        <td class="table-cell-start">{{ row.cmtNm }}</td>
                        <td class="table-cell"><span dir="ltr">{{ row.crtdDt | date: 'dd-MMM-yyyy' }}</span></td>
                        <td class="table-cell-end table-action-cell">
                            <div class="table-actions">
                                @for (action of actions; track $index) {
                                    <button class="action-btn cursor-pointer"
                                        [ngClass]="action.class" [attr.title]="action.tooltip | translate"
                                        [hidden]="!isActionVisible(action, row)"
                                        (click)="action.onClick(row); $event.stopPropagation()">
                                        @if (action.icon) {
                                            <fa-icon [icon]="action.icon" class="w-full h-full"></fa-icon>
                                        }
                                    </button>
                                }
                            </div>
                        </td>
                    </tr>

                    @if (isCommitteeExpanded(row)) {
                        <tr>
                            <td colspan="3" class="p-0">
                                <div class="table-wrapper overflow-x-auto">
                                    <table class="committee-child-table">
                                        <thead>
                                            <tr>
                                                <th>{{ 'ONB_PERSON.FULL_NAME' | translate }}</th>
                                                <th>{{ 'ONB_PERSON.CNIC_PASSPORT' | translate }}</th>
                                                <th>{{ 'ONB_PERSON.ISSUE_DATE' | translate }}</th>
                                                <th>{{ 'ONB_PERSON.DATE_OF_BIRTH' | translate }}</th>
                                                <th class="action-cell">{{ 'COMMON.ACTION' | translate }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            @if (!row.members?.length) {
                                                <tr>
                                                    <td colspan="5" class="text-center text-gray-400">
                                                        {{ 'ONB_COMMITTEE.NO_MEMBERS_ASSIGNED' | translate }}
                                                    </td>
                                                </tr>
                                            }
                                            @for (member of row.members; track member.prsnSeq) {
                                                <tr>
                                                    <td>{{ member.flNm }}</td>
                                                    <td>{{ member.cnc || member.psprt }}</td>
                                                    <td><span dir="ltr">{{ (member.cnc ? member.cncIssuDt : member.psprtIssuDt) | date: 'dd-MMM-yyyy' }}</span></td>
                                                    <td><span dir="ltr">{{ member.dob | date: 'dd-MMM-yyyy' }}</span></td>
                                                    <td class="action-cell">
                                                        <div class="table-actions">
                                                            <button class="action-btn cursor-pointer action-view" [title]="'COMMON.VIEW' | translate"
                                                                (click)="openMemberOnlyPopup(member, true); $event.stopPropagation()">
                                                                <fa-icon [icon]="viewIcon" class="w-full h-full"></fa-icon>
                                                            </button>
                                                            @if (canEditMember(member)) {
                                                                <button class="action-btn cursor-pointer action-edit" [title]="'COMMON.EDIT' | translate"
                                                                    (click)="openMemberOnlyPopup(member); $event.stopPropagation()">
                                                                    <fa-icon [icon]="icons.edit" class="w-full h-full"></fa-icon>
                                                                </button>
                                                            }
                                                            <button class="action-btn cursor-pointer action-delete" [title]="'COMMON.DELETE' | translate"
                                                                (click)="openRemoveMemberPopup(row, member); $event.stopPropagation()">
                                                                <fa-icon [icon]="icons.delete" class="w-full h-full"></fa-icon>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </td>
                        </tr>
                    }
                }

                @if (!list.length) {
                    <tr>
                        <td colspan="3" class="table-cell text-center text-gray-400">{{ 'ONB_COMMITTEE.NO_COMMITTEES_AVAILABLE' | translate }}</td>
                    </tr>
                }
            </tbody>
        </table>
    </div>

    <div class="flex ">
        <button class="btn-primary" (click)="goToNext()">{{ 'COMMON.CONTINUE' | translate }}</button>
    </div>
</div>  


<app-popup [(show)]="showPopup" [title]="isEditMode ? 'ONB_COMMITTEE.EDIT_COMMITTEE' : 'ONB_COMMITTEE.ADD_COMMITTEE'" [type]="'form'"
    [fields]="fields" [data]="formData" [onSave]="handleSave" (formChange)="onPopupFormChange($event)"
    width="w-full max-w-md min-w-[300px]"></app-popup>

<app-popup [(show)]="showDeletePopup" title="ONB_COMMITTEE.DELETE_COMMITTEE" [type]="'confirm'" [message]="deleteMessage"
    confirmText="COMMON.DELETE" cancelText="COMMON.CANCEL" (confirmed)="confirmDeleteCommittee()"></app-popup>

<app-popup [(show)]="showRemoveMemberPopup" title="ONB_COMMITTEE.REMOVE_MEMBER" [type]="'confirm'" [message]="removeMemberMessage"
    confirmText="COMMON.DELETE" cancelText="COMMON.CANCEL" (confirmed)="confirmRemoveMember()"></app-popup>

<app-popup [(show)]="showMemberOnlyPopup" [title]="isMemberOnlyPopupViewMode ? 'ONB_COMMITTEE.VIEW_COMMITTEE_MEMBER' : memberOnlyFormData.prsnSeq ? 'ONB_COMMITTEE.EDIT_COMMITTEE_MEMBER' : 'ONB_COMMITTEE.ADD_COMMITTEE_MEMBER'" [type]="'form'"
    [fields]="memberOnlyFields" [data]="memberOnlyFormData" [onSave]="handleMemberOnlySave"
    [showFileDownload]="isMemberOnlyPopupViewMode || !!memberOnlyFormData.prsnSeq"
    (formChange)="onMemberOnlyPopupFormChange($event)"
    width="w-full max-w-5xl"></app-popup>

<app-popup [(show)]="showSelectMembersPopup" (showChange)="!$event && closeSelectMembersPopup()"
    title="ONB_COMMITTEE.SELECT_MEMBERS" [type]="'custom'" width="w-full max-w-lg min-w-[300px]">

    @if (membersLoading) {
    <div class="text-sm text-gray-500 mb-2">{{ 'ONB_COMMITTEE.LOADING_MEMBERS' | translate }}</div>
    }

    <div class="relative">
        <label class="form-label mb-2 block">{{ 'ONB_COMMITTEE.SELECT_MEMBER' | translate }}</label>

        <button type="button" class="form-select w-full flex items-center justify-between text-start"
            (click)="toggleMembersDropdown()">
            <span class="truncate">{{ selectedMembersLabel }}</span>
            <span class="text-gray-400">&#9662;</span>
        </button>

        @if (membersDropdownOpen) {
            <div class="mt-1 w-full max-h-40 overflow-y-auto rounded-lg border border-gray-300 bg-white shadow-lg">
                @for (member of availableMembers; track member.prsnSeq) {
                    <div class="flex items-center justify-between px-3 py-2 text-sm text-gray-900 cursor-pointer hover:bg-gray-50"
                        (click)="toggleMemberSelection(member)">
                        <span>{{ member.flNm }}</span>
                        @if (isMemberPreSelected(member)) {
                            <fa-icon [icon]="checkIcon" class="text-green-500"></fa-icon>
                        }
                    </div>
                }
                @if (!availableMembers.length) {
                    <div class="px-3 py-2 text-sm text-gray-400">{{ 'ONB_COMMITTEE.NO_MEMBERS_AVAILABLE' | translate }}</div>
                }
            </div>
        }
    </div>

    <div class="px-6 py-4 border-t flex justify-end gap-3 mt-4">
        <button class="btn-primary" [disabled]="!selectedMemberPrsnSeqs.length" (click)="saveMembers()">{{ 'ONB_COMMITTEE.SAVE_MEMBER' | translate }}</button>
        <button class="btn-danger" (click)="closeSelectMembersPopup()">{{ 'COMMON.CANCEL' | translate }}</button>
    </div>
</app-popup>
